import { render, staticRenderFns } from "./visited.vue?vue&type=template&id=2ca6c1b7&scoped=true&"
import script from "./visited.vue?vue&type=script&lang=js&"
export * from "./visited.vue?vue&type=script&lang=js&"
import style0 from "./visited.vue?vue&type=style&index=0&id=2ca6c1b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6c1b7",
  null
  
)

export default component.exports